import { IControls } from '../../../../../components/ABSForm';
import { formatInternalMessageContent } from '../../../../../components/ABSFormModal/util';

export interface ItemData {
  message: {
    id: number;
    title: string;
    date: string;
    markStatus?: boolean;
    status?: string;
    content: string;
  };
  user: {
    // 收件箱--发件人 ； 发件箱--收件人
    name: string;
    avatar?: string;
    userId: string;
    userName?: string;
  };
  antiUser: {
    // 信息持有人
    name: string;
    avatar?: string;
    userId?: string;
    userName?: string;
  };
}

export function renderControls(
  data: ItemData,
  isReceipt?: boolean,
  validator?: () => void
): IControls[] {
  const datas: IControls[] = [
    {
      type: 'search',
      label: '收件人',
      id: 'user_ids',
      required: true,
      placeholder: '收件人',
      style: { width: 400 },
      defaultValue: [{ key: data.user.userId, label: data.user.name }],
      multipleMaxNum: 1,
      isForm: true,
    },
    {
      type: 'input',
      label: '站内信主题',
      id: 'title',
      required: true,
      defaultValue: 'Re：' + data.message.title,
      style: { width: 668 }
    },
    {
      type: 'textarea',
      label: '站内信内容',
      id: 'content',
      className: 'internal-message-textarea-write',
      style: { width: 668, height: 366 },
      defaultValue: formatInternalMessageContent({
        sender: isReceipt ? data.user.name : data.antiUser.name,
        recipient: isReceipt ? data.antiUser.name : data.user.name,
        time: data.message.date,
        title: data.message.title,
        content: data.message.content
      })
    }
  ];
  return datas;
}

export function getDateStr(AddDayCount: number) {
  var dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount); // 获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1; // 获取当前月份的日期
  var d = dd.getDate();
  return y + '-' + m + '-' + d;
}

export function timeFomat(time: any) {
  const getTime = time
    .replace(/[:-]/g, '')
    .trim()
    .toString();
  const year = getTime.substring(0, 4);
  const month = getTime.substring(4, 6);
  const day = getTime.substring(6, 8);
  const hour = getTime.substring(9, 11);
  const minute = getTime.substring(11, 13);
  const createTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
  const date3 = getDateStr(-1); // 昨天
  const str3 = date3.split('-');
  str3[1] = str3[1].length === 1 ? '0' + str3[1] : str3[1];
  str3[2] = str3[2].length === 1 ? '0' + str3[2] : str3[2];
  const date0 = getDateStr(0); // 今天
  const str0 = date0.split('-');
  str0[1] = str0[1].length === 1 ? '0' + str0[1] : str0[1];
  str0[2] = str0[2].length === 1 ? '0' + str0[2] : str0[2];
  if (year === str3[0] && month === str3[1] && day === str3[2]) {
    return '昨天' + ' ' + hour + ':' + minute;
  } else if (year === str0[0] && month === str0[1] && day === str0[2]) {
    return '今天' + ' ' + hour + ':' + minute;
  } else {
    return createTime;
  }
}

// 更新未读消息状态数
export function setMessageUnreadCount(dispatch: any) {
  dispatch({
    type: 'global/getMessageUnreadCount',
    payload: {}
  });
}

export function updatedReceiveMessageDataStructure(data: any): Array<ItemData> {
  if (data && Array.isArray(data)) {
    data.forEach(item => {
      item.user = item.sender;
      item.antiUser = emptyRecipients(item.recipients[0]);
      delete item.sender;
      delete item.recipients;
    });
    return data;
  }
  return [
    {
      user: data.sender,
      message: data.message,
      antiUser: emptyRecipients(data.recipients[0])
    }
  ];
}

export function updatedSendMessageDataStructure(data: any): Array<ItemData> {
  if (data && Array.isArray(data)) {
    data.forEach(item => {
      item.message = item.messageSent;
      item.user = emptyRecipients(item.recipients[0]);
      item.antiUser = item.sender;
      delete item.messageSent;
      delete item.sender;
      delete item.recipients;
    });
    return data;
  }
  return [
    {
      user: emptyRecipients(data.recipients[0]),
      message: data.messageSent,
      antiUser: data.sender
    }
  ];
}

function emptyRecipients(value: any) {
  if (!value) {
    const newValue = {
      name: '',
      avatar: '',
      userId: '',
      userName: ''
    };
    return newValue;
  }
  return value;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/account/InternalMessage/entities/data.ts